// import Vue from 'vue'
import consts from "@/consts"
//adding new templates needs to be added to routing !!!
const additional_reports_templates = !consts.app.$isPrometheus ? [
        //system
        {id: 'trips', icon: 'reports_trips', title: 'Trips', type: 'system', params: {unit: true, units_group: false, all: consts.app.$isTestVersion}},
        {id: 'idlings', icon: 'reports_idling', title: 'Idling', type: 'system', params: {unit: true, units_group: false, all: consts.app.$isTestVersion}},
        {id: 'trips-parkings', icon: 'reports_parkings', title: 'Trips/Parkings', type: 'system', params: {unit: true, units_group: false, all: consts.app.$isTestVersion}},
        {id: 'statistics', icon: 'reports_statistics', title: 'Statistics', type: 'system', params: {unit: true, units_group: false, all: consts.app.$isTestVersion}},
        {id: 'asset-utilization', icon: 'asset-utilization-report', title: 'Asset Utilization', type: 'system', params: {unit: true, units_group: false, all: consts.app.$isTestVersion, filter: {hw_types: ['m2m','xcargo_m2m','xcargo_m2m_oneway']}}},
        {id: 'battery-health-check', icon: 'battery-report', title: 'Battery Health Check', type: 'system', params: {unit: true, units_group: false, all: true,  filter: {hw_types: ['m2m','xcargo_m2m','xcargo_m2m_oneway']}}},
        {id: 'mileage', icon: 'reports_trips', title: 'Mileage Report', type: 'system', params: {unit: true, units_group: false, all: consts.app.$isTestVersion}},
        {id: 'camera-events', icon: 'camera', title: 'Camera Events', type: 'system', params: {unit: true, units_group: false, all: false, filter: {hasVideo: true}}},
    ] : [
        //system
        {id: 'trips', icon: 'reports_trips', title: 'Trips', type: 'system', params: {unit: true, units_group: true, all: consts.app.$isTestVersion}},
        {id: 'idlings', icon: 'reports_idling', title: 'Idling', type: 'system', params: {unit: true, units_group: true, all: consts.app.$isTestVersion}},
        {id: 'trips-parkings', icon: 'reports_parkings', title: 'Trips/Parkings', type: 'system', params: {unit: true, units_group: true, all: consts.app.$isTestVersion}},
        {id: 'statistics', icon: 'reports_statistics', title: 'Statistics', type: 'system', params: {unit: true, units_group: true, all: consts.app.$isTestVersion}},
        {id: 'battery-health-check', icon: 'battery-report', title: 'Battery Health Check', type: 'system', params: {unit: true, units_group: true, all: true, filter: {hw_types: ['m2m','xcargo_m2m','xcargo_m2m_oneway']}}},
        {id: 'mileage', icon: 'reports_trips', title: 'Mileage Report', type: 'system', params: {unit: true, units_group: true, all: consts.app.$isTestVersion}},
        {id: 'asset-last-connection', icon: 'circle__lost-connection', title: 'Asset Last Connection', type: 'system', params: {unit: true, units_group: true, all: true, steps: ['objects']}},
        //api
        {id: 2427, icon: 'geozones-visits-report', title: 'Geozones Visits', type: '', params: {unit: true, units_group: true, all: consts.app.$isTestVersion, geozone: true, geozone_group: true, steps: ['objects', 'geozones', 'period']}},
        {id: 2376, icon: 'posted-speed-limit-report', title: 'Posted Speed Limit', type: '', params: {unit: true, units_group: true, all: consts.app.$isTestVersion, steps: ['objects', 'period']}},
        {id: 2434, icon: 'unauthorized-parking-report', title: 'Unauthorized Parking Report', type: '', params: {unit: true, units_group: true, geozone: true, geozone_group: true, all: consts.app.$isTestVersion, steps: ['objects', 'geozones', 'datetime']}},
        {id: 'vision_md', icon: 'empty', title: 'Vision MD', type: '', params: {}, disabled: true},
        {id: 'maintenance', icon: 'empty', title: 'Maintenance', type: '', params: {}, disabled: true},
        {id: 'driver_core_card', icon: 'empty', title: 'Driver Score Card', type: '', params: {}, disabled: true},
        {id: 'vision_alerts', icon: 'empty', title: 'Vision Alerts', type: '', params: {}, disabled: true},

        // {id: 4, icon: 'reports_fuel', title: 'Fuel'},
        // {id: 5, icon: 'reports_driving', title: 'Driving Behavior'},
        // {id: 6, icon: 'empty', title: 'Vision MD'},
        // {id: 7, icon: 'empty', title: 'ELD'},
        // {id: 8, icon: 'reports_alarms', title: 'Alarms'},
        // {id: 9, icon: 'reports_idling', title: 'Idling'},
        // {id: 10, icon: 'empty', title: 'GeoFonce'},
];

export default {
    state: {
        reports_templates: [
            {id: 'msgs', icon: 'reports_raw', title: 'Raw data', type: 'system', params: {unit: true, units_group: false}},
            ...additional_reports_templates,
        ],
    },
    actions: {
        //fetchReportsTemplates
    },
    mutations: {},
    getters: {
        getReportsTemplates(state) {
            return state.reports_templates
        },
        getReportsTemplatesByIds(state) {
            return state.reports_templates
                .reduce((rtsById, report) => {
                    rtsById[report.id] = report
                    return rtsById
                }, {})
        },

    }
}